import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { TableProps } from './types'

const TableContainerStyled = styled.div`
  width: 100%;
`

const TableStyled = styled.div`
  width: 100%;
`

const TableRowBodyStyled = styled.div`
  display: none;
  width: 100%;
`

const TableColumnStyled = styled.div`
  flex: 1;
  padding: 1.375rem 1rem 1.125rem;
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  word-break: break-word;

  @media ${media.maxPhone} {
    &:nth-of-type(2) {
      padding-left: 0;
      width: 25%;
    }
    &:nth-of-type(3) {
      flex: 2;
      width: 65%;
    }
    &:nth-of-type(1n + 4) {
      display: none;
    }
  }

  @media ${media.phone} {
    font-size: 0.875rem;
    padding: 1rem;
    text-align: center;

    &:nth-of-type(2) {
      ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
    }
  }
`

const TableHeadStyled = styled.div<WithTheme>`
  display: flex;
  color: ${({ theme }) => theme.colors.green};

  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.gray5_20};

  ${TableColumnStyled} {
    text-transform: capitalize;
  }

  @media ${media.maxPhone} {
    padding-bottom: 1.25rem;
  }
`

const TableIconStyled = styled.div<WithTheme>`
  display: flex;
  justify-content: center;

  padding: 1.375rem 0.625rem 1.125rem;
  width: 1.875rem;
  color: ${({ theme }) => theme.colors.green};
  svg {
    ${transition}
    width: 0.625rem;
    font-size: 0.625rem;
    margin-top: 0.25rem;
  }
  @media ${media.phone} {
    width: 0;
    display: none;
  }
`

const TableRowHeadStyled = styled.div<WithTheme<TableProps>>`
  ${transition}
  display: flex;
  width: 100%;

  @media ${media.phone} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.green};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  ${TableColumnStyled} {
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    &:nth-of-type(2) {
      font-weight: ${({ theme }) => theme.fontWeights.semibold};
    }
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      @media ${media.maxPhone} {
        & + ${TableRowBodyStyled} {
          display: block;
          margin-bottom: 1.875rem;
        }

        ${TableIconStyled} {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    `};
`

const TableRowStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;

  &:not(:last-of-type) {
    ${TableRowHeadStyled} {
      border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.gray5_20};
    }
  }
`

const TableSubRowStyled = styled.div<WithTheme>`
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray4_10};

  &:nth-of-type(even) {
    background-color: ${({ theme }) => theme.colors.white};
  }
`

const TableSubRowColumnStyled = styled.div<WithTheme>`
  width: 45%;
  padding: 0.5rem 1.875rem;
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  &:first-of-type {
    color: ${({ theme }) => theme.colors.green};
    width: 55%;
  }
`

const TablePaginationStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3.125rem;
  width: 100%;
`

export {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableRowHeadStyled,
  TableRowBodyStyled,
  TableColumnStyled,
  TableIconStyled,
  TableSubRowStyled,
  TableSubRowColumnStyled,
  TablePaginationStyled
}
